import { GoogleMap, LoadScript, MarkerF } from '@react-google-maps/api';

interface Location {
  lat: number;
  lng: number;
}

interface GooglemapProps {
  location?: Location;
  width?: string;
  height?: string;
  zoom?: number;
  className?: string;
  title?: string;
  phone?: string;
  address?: string;
}

export const KOREA_LOCATION: Location = {
  lat: 37.5547350,
  lng: 126.9215528,
};

export const GLOBAL_LOCATION: Location = {
  lat: 39.7447857,
  lng: -104.9931479,
};

// TODO: 실제 주소/좌표 확정 후 교체
export const KOREA_2_LOCATION: Location = {
  lat: 37.5580377,
  lng: 127.0474892,
};

// TODO: 실제 주소/좌표 확정 후 교체
export const EUROPE_LOCATION: Location = {
  lat: 49.5023669,
  lng: 5.9485493,
};

export interface Office {
  location: Location;
  title: string;
  address: string;
}

export const OFFICES: Office[] = [
  {
    location: KOREA_LOCATION,
    title: 'South Korea (HQ)',
    address: '#606, 136, Yanghwa-ro, Mapo-gu, Seoul 04038, Republic of Korea',
  },
  {
    location: KOREA_2_LOCATION,
    title: 'South Korea (R&D Center)',
    address: '705-802/805, Multidisciplinary Lecture Hall, 2222, Wangsimni-ro, Seongdong-gu, Seoul 04763, Republic of Korea',
  },
  {
    location: GLOBAL_LOCATION,
    title: 'United States',
    address: '1630 Welton St, PMB 903 Denver, Colorado, 80202, USA',
  },
  {
    location: EUROPE_LOCATION,
    title: 'Luxembourg',
    address: '9, avenue des Hauts-Fourneaux L-4362 Esch-sur-Alzette, Luxembourg',
  },
];

const MAP_STYLES = [
  {
    featureType: 'poi',
    elementType: 'labels',
    stylers: [{ visibility: 'off' }],
  },
];

const DEFAULT_MAP_OPTIONS = {
  styles: MAP_STYLES,
};

const Googlemap = ({
  location = KOREA_LOCATION,
  width = '30rem',
  height = '20rem',
  zoom = 2,
  className = '',
  title,
  phone,
  address,
}: GooglemapProps) => {
  const mapContainerStyle = {
    width,
    height,
  };

  return (
    <div className={`flex flex-col items-center h-full ${className}`}>
      <LoadScript
        googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ''} // 지도 표시용 - 제한된 API 키 사용 권장
        language='en'
        libraries={['places']}
      >
        <GoogleMap
          mapContainerStyle={mapContainerStyle}
          center={location}
          zoom={zoom}
          options={DEFAULT_MAP_OPTIONS}
        >
          <MarkerF position={location} />
        </GoogleMap>
      </LoadScript>
      {title && (
        <div className='flex flex-1 bg-[#ffffff] px-2 py-2 md:px-6 md:py-4 w-full max-w-full overflow-hidden min-h-[80px] md:min-h-[150px] xl:min-h-[120px] items-start justify-center'>
          <div className='flex flex-col gap-1 w-full'>
            <div className='flex flex-row gap-4 items-center flex-wrap'>
              <h3 className='text-xl md:text-2xl font-bold text-black'>
                {title}
              </h3>
              <p className='text-xl md:text-2xl font-semibold text-black'>
                {phone}
              </p>
            </div>
            {address && (
              <p className='text-[14px] md:text-base text-black break-words whitespace-normal w-full'>
                {address}
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Googlemap;
